import { Component, Input, SimpleChanges } from '@angular/core';
import { Animations } from 'src/app/animations';
import { HorizontalItemRow } from 'src/app/model/horizontal-graph';

@Component({
  selector: 'app-horizontal-bar',
  templateUrl: './horizontal-bar.component.html',
  styleUrls: ['./horizontal-bar.component.scss'],
  animations: [
    Animations.openClose
  ]
})
export class HorizontalBarComponent {
  @Input() maxValue: number = 1;
  @Input() selected: boolean = false;
  @Input() withGestures: boolean = true;
  @Input() item: HorizontalItemRow = {} as HorizontalItemRow;

  public width: number = 0;
  public isMoreInfoOpen: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.width = (this.item.value.value / this.maxValue) * 100;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selected'].currentValue === false) {
      this.isMoreInfoOpen = false;
    }
  }
}
